import { appstr } from "./appstr";

export function NoChainOfCmd() {
  return "[" + appstr("chainofcommand") + "]";
}
